import React from 'react';
import { ConvertStringToHtmlId } from '../../libs/ts/ConvertStringToHtmlId';

export interface props {
  title: string;
  description?: string;
  onSelected: (checked: boolean) => void;
  checked: boolean;
  group?: string;
  readonly?: boolean;
}

export const Checkbox = (props: props) => {
  const checkboxTitle = ConvertStringToHtmlId(props.title);

  const handleCheckboxSelected = React.useCallback(() => {
    if (props.readonly) return;
    return props.onSelected(!props.checked);
  }, [props]);

  return (
    <div>
      <div className="flex flex-row w-full" onClick={handleCheckboxSelected}>
        <input
          type="checkbox"
          id={checkboxTitle}
          name={props.group ?? props.title}
          value={checkboxTitle}
          checked={props.checked}
          onChange={handleCheckboxSelected}
          className={`translate-y-1 w-4 h-4 appearance-none checked:appearance-auto accent-solid-bold-green border-[2px] rounded-[2px] border-secondary-deep-blue-30 bg-interactive-bold-green-db-12 checked:border-solid-bold-green ${!props.readonly ? 'hover:border-solid-bold-green' : ''}`}
        />
        <label className="ml-7">{props.title}</label>
      </div>

      {props.description !== undefined && (
        <span
          className={`block whitespace-pre-wrap mt-3 mb-5 ml-8 mr-8 leading-6 text-sm text-secondary-deep-blue-20 font-italic overflow-hidden transition-[max-height] ease-in duration-300 max-h-0`}
        >
          {props.description}
        </span>
      )}
    </div>
  );
};
